/* smooth open/close for the collapsible-content (faq) accordion.
   native <details> snaps open/close with no transition. this hooks the
   summary click, cancels the instant toggle, and animates the content
   height instead — same blagi prelaz as the product page accordion.
   scoped to .collapsible-content only; product/easytabs accordions untouched.
   respects prefers-reduced-motion (no js animation → native instant toggle). */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DURATION = 450;
  var EASING = 'cubic-bezier(0.32, 0.72, 0, 1)'; // premium ease-out (matches modal panel) — slow, elegant settle

  function setupDetails(details) {
    if (details.dataset.omgAnimated) return;
    details.dataset.omgAnimated = '1';

    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    var anim = null;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      // let an in-flight animation finish its current frame, then reverse
      if (anim) anim.cancel();
      content.style.overflow = 'hidden';
      if (details.open) {
        shrink();
      } else {
        expand();
      }
    });

    function expand() {
      details.classList.add('is-open'); // caret rotates immediately, smoothly
      details.open = true; // reveal so we can measure full height
      var end = content.offsetHeight;
      anim = content.animate(
        { height: ['0px', end + 'px'] },
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = cleanup;
      anim.oncancel = cleanup;
    }

    function shrink() {
      details.classList.remove('is-open'); // caret rotates back immediately
      var start = content.offsetHeight;
      anim = content.animate(
        { height: [start + 'px', '0px'] },
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = function () {
        details.open = false; // collapse only after the animation plays
        cleanup();
      };
      anim.oncancel = cleanup;
    }

    function cleanup() {
      content.style.overflow = '';
      anim = null;
    }
  }

  function init(root) {
    (root || document)
      .querySelectorAll('.collapsible-content .accordion details')
      .forEach(setupDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // theme editor: re-bind when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
